import { objectKeys } from '@helpers/utils'
import React from 'react'
import styles from './styles.module.scss'

const PROPERTY_NAMES = {
  color: 'Colour',
  waist: 'Waist',
  build: 'Build',
  leg: 'Leg',
  shortsleg: 'Leg',
  cut: 'Cut',
  length: 'Length',
  size: 'Size',
  chest_size: 'Chest',
  taper: 'Lower Leg',
  amount: 'Amount'
} as const

type Property = keyof typeof PROPERTY_NAMES

type ProductPropertyProps = {
  propertyName: Property
  propertyValue: string | undefined
  newPropertyValueToCompare?: string
}

const ProductProperty = ({
  propertyName,
  propertyValue,
  newPropertyValueToCompare
}: ProductPropertyProps) => {
  return propertyValue ? (
    <div className={styles.productProperties__content}>
      <p className={styles.productProperties__name}>
        {PROPERTY_NAMES[propertyName.toLowerCase() as Property]}
      </p>
      <div className={styles.productProperties__values}>
        {propertyValue !== newPropertyValueToCompare && (
          <p
            className={`${
              newPropertyValueToCompare
                ? styles.productProperties__newValue
                : ''
            }`}
          >
            {propertyValue}
          </p>
        )}
        {newPropertyValueToCompare && <p>{newPropertyValueToCompare}</p>}
      </div>
    </div>
  ) : null
}

type Properties = Record<Property, string>

export type ProductCardPropertiesProps = {
  properties: Partial<Properties>
  newPropertiesToCompare?: ProductCardPropertiesProps['properties']
}

const ProductCardProperties = ({
  properties,
  newPropertiesToCompare
}: ProductCardPropertiesProps) => {
  return (
    <div className={styles.productProperties}>
      {objectKeys(properties).map(itemKey => (
        <ProductProperty
          key={itemKey}
          propertyValue={properties[itemKey as Property]}
          newPropertyValueToCompare={
            newPropertiesToCompare &&
            newPropertiesToCompare[itemKey as Property]
          }
          propertyName={itemKey}
        />
      ))}
    </div>
  )
}

export default ProductCardProperties
